// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"SenderEmail_buttonsContainer__hCsSm","hint":"SenderEmail_hint__fS4mQ"};